export const openUpgradeOfferPianoModal = () => {
  window.tp.push(['setCustomVariable', 'isRestrictedAccess', true]);
  return window.tp.experience.execute();
};
